var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.url)?_c('div',{staticClass:"goodsAreaTitle",style:(`background-image:url(${_vm.item.url})`)},[_vm._v("悦享美食")]):_vm._e(),_c('GoodsListWaterfall',{attrs:{"goods_data_right":_vm.goods_data_right,"goods_data_left":_vm.goods_data_left}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }